<template>
    <div>
        <van-nav-bar      left-text="返回" @click-left="back"    left-arrow/>
        <div class="pt46">
            <p style="font-weight: bold;font-size: 16px;text-align: center;padding: 10px 5px;">{{text.title}}</p>
            <p style="font-size: 14px;text-align: center;">更新时间:{{text.updated_at}}</p>
		    <div class='imgBox' style="font-size: 14px;text-align: center;padding: 5px;">
                <img width='100%' :src="webImgUrl+text.thumb" alt="">                
		    </div>
            <p style="font-size: 14px;padding: 5px 10px;line-height:20px" v-html='text.content'>
			    {{text.content}}
		    </p>
        </div>
    </div>
</template>

<script>
import {getnewsShow} from '@/request/data'
export default {
    name:'articleDetails',
    data() {
        return {
            text:[],
            webImgUrl:this.$store.state.imgURL
        }
    },
    mounted() {
        this.$toast({
            type:'loading',
            message:'加载中...',
            duration: 0,
            forbidClick: true, // 禁用背景点击
        });
        let id = this.$route.query.id
        getnewsShow(id).then(res=>{
            this.$toast.clear()
            if (res.data.code == 0) {
                this.text = res.data.data
            }
            console.log(res)
        })
    },
    methods: {
        back(){
            this.$router.back(-1)
        }
    },
}
</script>

<style  scoped>
.imgBox{
    box-sizing: border-box;
    width: 100%;
    /* height: 250px; */
    margin-bottom: 16px;
    padding: 16px;
    background-color: white;
    background-repeat: no-repeat;
    background-position: 16px;
    background-size: 315px 250px;
    padding:5px;
    margin:10px 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
</style>